module.exports = __webpack_public_path__ + "img/sons_of_the_north.b574bb6e.jpg";